import { IBingoJackpot } from 'js/hooks/socket/hooks/useGetBingoJackpots/types';

import { IJackpot, TJackpots, IJackpotTicker, IGetJackpotParams, IExternalJackpots } from './types';

export const getJackpot = ({
    amount = 0,
    step,
    currency,
    hitTime = null,
    betDependent = false
}: IGetJackpotParams): IJackpot => ({
    currencyCode: currency,
    step: Number(step) || 0.01,
    amount: amount * 0.99,
    originAmount: amount,
    hitTime,
    betDependent
});

export const parseJackpots = (gameData: { [gameCode: string]: IJackpotTicker } = {}, currencyCode: string): TJackpots => {
    const jackpots: TJackpots = {};

    for (const [code, data] of Object.entries(gameData)) {
        const {
            highestAmount: {
                [currencyCode]: amount
            } = {},
            highestGuaranteedHitTime,
            betDependent = false
        } = data || {};

        jackpots[code] = getJackpot({
            amount: Number(amount),
            betDependent,
            step: 0,
            currency: currencyCode,
            hitTime: highestGuaranteedHitTime && new Date(highestGuaranteedHitTime).getTime()
        });
    }

    return jackpots;
};

export const parseCasinoJackpot = (
    json: { [totalAmount: string]: { [currencyCode: string]: string } }, currencyCode: string
): IJackpot => {
    const {
        totalAmount: {
            [currencyCode]: amount
        } = {}
    } = json || {};

    return getJackpot({
        amount: Number(amount),
        step: 0,
        currency: currencyCode
    });
};

export const parseVFJackpots = (vfJackpots: IBingoJackpot[] = []): { [gameCode: string]: IJackpot } => vfJackpots.reduce((games, {
    jackpotName: gameCode,
    jackpotAmount: amount,
    Step: step,
    currency: currency
}) => {
    const game = getJackpot({
        amount,
        step: Number(step),
        currency: currency || ''
    });

    return Object.assign(games, { [gameCode]: game });
}, {});

export const parseExternalJackpots = (
    jackpotsData: IExternalJackpots[], currencyCode: string
): Record<string, IJackpot> => {
    const jackpotMap = new Map<string, IJackpot>();

    jackpotsData.forEach(({ jackpotNetworks = [] }) => {
        jackpotNetworks.forEach(({ jackpots = [] }) => {
            jackpots.forEach(({ balances = [], gameIds = [], betDependent = false }) => {
                const { amount } = balances.find((balance) => balance.currencyCode === currencyCode) || {};

                if (!amount) {
                    return;
                }

                gameIds.forEach((gameId) => {
                    const storedJackpot = jackpotMap.get(gameId);

                    if (!storedJackpot || storedJackpot.amount < amount) {
                        jackpotMap.set(gameId, getJackpot({
                            amount,
                            betDependent,
                            currency: currencyCode
                        }));
                    }
                });
            });
        });
    });

    return Object.fromEntries(jackpotMap);
};
